import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SuccessCase extends DexResourceModel {
   
    @Field(String)
	public name: string = "";
    @Field(String)
	public frequentCallerId: string = "";
    @Field(String)
	public caseNumber: string = "";
    @Field(String)
	public vendor_uuid: string = "";
    @Field(String)
	public successAccount_uuid: string = "";
    @Field(String)
	public corpId: string = "";
    @Field(String)
	public clientMatterNumber: string = "";
    @Field(Boolean)
	public isRestricted: boolean = false;
    @Field(Date)
    public createdAt: Date = new Date();
	@Field(Date)
	public updatedAt: Date = new Date();
    @Field(Date)
	public deletedAt: Date | null = null; 
    @Field(String)
    public court_AddressBook_uuid: string = "";
    @Field(String)
    public caseNumberNormalized: string | null = null
 
    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get data(): any {
        let json = super.data;

        return json;
    }

}
